module.exports = __webpack_public_path__ + "img/paymentMethod.841d25cc.png";